import { useState } from 'react';
import { DataModelsList } from '../components/datamodels';
import { DataModelWizard } from '../components/datamodels/DataModelWizard';

export default function DataModelsPage() {
    const [view, setView] = useState<'list' | 'wizard'>('list');
    const [selectedDataModelId, setSelectedDataModelId] = useState<string | null>(null);

    // If view is wizard, render the wizard
    if (view === 'wizard') {
        return (
            <div className="h-full w-full">
                <DataModelWizard
                    isOpen={true}
                    dataModelId={selectedDataModelId}
                    onClose={() => {
                        setView('list');
                        setSelectedDataModelId(null);
                    }}
                    onSuccess={() => {
                        setView('list');
                        setSelectedDataModelId(null);
                    }}
                />
            </div>
        );
    }

    return (
        <DataModelsList
            onEdit={(id: string) => {
                setSelectedDataModelId(id);
                setView('wizard');
            }}
            onCreate={() => {
                setSelectedDataModelId(null);
                setView('wizard');
            }}
        />
    );
}
